import Card from '../Card';

const RatingSkeleton: React.FC = () => (
  <Card>
    <div className="animate-pulse">
      <div className="flex justify-between items-center gap-2 flex-wrap mb-2">
        <div className="flex items-center gap-2">
          <div className="w-8 h-8 rounded-full bg-gray-200"></div>
          <div>
            <div className="h-5 w-32 bg-gray-200 rounded mb-1"></div>
            <div className="h-4 w-24 bg-gray-200 rounded"></div>
          </div>
        </div>
        <div className="flex items-center gap-1">
          {[...Array(5)].map((_, i) => (
            <div key={i} className="h-5 w-5 bg-gray-200 rounded-sm"></div>
          ))}
        </div>
      </div>
      <div className="h-4 w-full bg-gray-200 rounded mb-2"></div>
      <div className="h-4 w-3/4 bg-gray-200 rounded mb-4"></div>
      <div className="flex space-x-3">
        <div className="h-12 w-full bg-gray-200 rounded-2xl"></div>
        <div className="h-12 w-full bg-gray-200 rounded-2xl"></div>
      </div>
    </div>
  </Card>
);

export default RatingSkeleton;
